export const BANNER_TYPES = {
  DEFAULT: 'default',
  SECONDARY: 'secondary',
  WARNING: 'warning',
  DANGER: 'danger'
};
